import Loadable from "react-loadable"
import Loading from "../views/components/shared/Loading"

import LogOut from "../views/pages/LogOut"
import NotFound from "../views/pages/NotFound"

const AsyncSignIn = Loadable({
		loader: () => import("../views/pages/SignIn"),
		loading: Loading,
	}),
	AsyncVerification = Loadable({
		loader: () => import("../views/pages/Verification"),
		loading: Loading,
	}),
	AsyncUnregisterVerification = Loadable({
		loader: () => import("../views/pages/UnregisterVerification"),
		loading: Loading,
	}),
	AsyncCSOLogin = Loadable({
		loader: () => import("../views/pages/CSOLogin"),
		loading: Loading,
	}),
	AsyncSignUp = Loadable({
		loader: () => import("../views/pages/SignUp"),
		loading: Loading,
	}),
	AsyncForgotPassword = Loadable({
		loader: () => import("../views/pages/ForgotPassword"),
		loading: Loading,
	}),
	AsyncForgotEmail = Loadable({
		loader: () => import("../views/pages/ForgotEmail"),
		loading: Loading,
	}),
	AsyncUnRegister = Loadable({
		loader: () => import("../views/pages/UnRegister"),
		loading: Loading,
	}),
	AsyncAccount = Loadable({
		loader: () => import("../views/pages/Account"),
		loading: Loading,
	}),
	AsyncContactUs = Loadable({
		loader: () => import("../views/pages/ContactUs"),
		loading: Loading,
	}),
	AsyncTransactions = Loadable({
		loader: () => import("../views/pages/Transactions"),
		loading: Loading,
	}),
	AsyncRewards = Loadable({
		loader: () => import("../views/pages/Rewards"),
		loading: Loading,
	}),
	AsyncProfile = Loadable({
		loader: () => import("../views/pages/Profile"),
		loading: Loading,
	}),
	AsyncCards = Loadable({
		loader: () => import("../views/pages/Cards"),
		loading: Loading,
	}),
	AsyncCardDetails = Loadable({
		loader: () => import("../views/pages/CardDetails"),
		loading: Loading,
	}),
	AsyncAddCard = Loadable({
		loader: () => import("../views/pages/AddCard"),
		loading: Loading,
	}),
	AsyncChangePassword = Loadable({
		loader: () => import("../views/pages/ChangePassword"),
		loading: Loading,
	}),
	AsyncTransactionDetails = Loadable({
		loader: () => import("../views/pages/TransactionDetails"),
		loading: Loading,
	}),
	AsyncResetPassword = Loadable({
		loader: () => import("../views/pages/ResetPassword"),
		loading: Loading,
	}),
	AsyncTransferBalance = Loadable({
		loader: () => import("../views/pages/TransferBalance"),
		loading: Loading,
	}),
	AsyncLandingPage = Loadable({
		loader: () => import("../views/pages/LandingPage"),
		loading: Loading,
	}),
	AsyncReportLossPage = Loadable({
		loader: () => import("../views/pages/ReportLoss"),
		loading: Loading,
	}),
	AsyncVerifyGoldCardAddressPage = Loadable({
		loader: () => import("../views/pages/VerifyGoldCardAddress"),
		loading: Loading,
	}),
	AsyncCardReloadPage = Loadable({
		loader: () => import("../views/pages/CardReload"),
		loading: Loading,
	}),
	AsyncCardReloadReturnPage = Loadable({
		loader: () => import("../views/pages/CardReloadReturn"),
		loading: Loading,
	}),
	AsyncEgiftPage = Loadable({
		loader: () => import("../views/pages/Egift"),
		loading: Loading,
	}),
	AsyncEgiftCardPage = Loadable({
		loader: () => import("../views/pages/EgiftCard"),
		loading: Loading,
	}),
	AsyncEgiftCardDetailPage = Loadable({
		loader: () => import("../views/pages/EgiftCardDetail"),
		loading: Loading,
	}),
	AsyncEgiftCardShoppingCartPage = Loadable({
		loader: () => import("../views/pages/EgiftCardShoppingCart"),
		loading: Loading,
	}),
	AsyncEgiftCardShoppingCartSuccessPage = Loadable({
		loader: () => import("../views/pages/EgiftCardShoppingCartSuccess"),
		loading: Loading,
	}),
	AsyncEgiftCardVerifyEgiftPage = Loadable({
		loader: () => import("../views/pages/EgiftCardVerifyEgift"),
		loading: Loading,
	}),
	AsyncVerifyVoucherBundlePage = Loadable({
		loader: () => import("../views/pages/VerifyVoucherBundle"),
		loading: Loading,
	}),
	AsyncEgiftCardRedemptionPage = Loadable({
		loader: () => import("../views/pages/EgiftCardRedemption"),
		loading: Loading,
	}),
	AsyncEgiftPurchaseHistoryPage = Loadable({
		loader: () => import("../views/pages/EgiftPurchaseHistory"),
		loading: Loading,
	}),
	AsyncEgiftPurchaseDetail = Loadable({
		loader: () => import("../views/pages/EgiftPurchaseDetail"),
		loading: Loading,
	})

const localeRegex = ":locale(en|vi)?"

const PublicRoutes = [
	{
		path: `/${localeRegex}/egift/card/redemption`,
		isPrivate: false,
		component: AsyncEgiftCardRedemptionPage,
	},
	{
		path: `/${localeRegex}/egift/card/verify`,
		isPrivate: false,
		component: AsyncEgiftCardVerifyEgiftPage,
	},
	{
		path: `/${localeRegex}/voucher/verify`,
		isPrivate: false,
		component: AsyncVerifyVoucherBundlePage,
	},
	{
		path: `/${localeRegex}/egift/card/shoppingcart/success`,
		isPrivate: false,
		component: AsyncEgiftCardShoppingCartSuccessPage,
	},
	{
		path: `/${localeRegex}/egift/card/shoppingcart`,
		isPrivate: false,
		component: AsyncEgiftCardShoppingCartPage,
	},
	{
		path: `/${localeRegex}/egift/card/:subDepartmentCode`,
		isPrivate: false,
		component: AsyncEgiftCardDetailPage,
	},
	{
		path: `/${localeRegex}/egift`,
		isPrivate: false,
		component: AsyncEgiftCardPage,
	},
	{
		path: `/${localeRegex}/landing-egift`,
		isPrivate: false,
		component: AsyncEgiftPage,
	},
	{
		path: `/${localeRegex}/*`,
		isPrivate: false,
		status: 404,
		component: NotFound,
	},
]

const Routes = [
	{
		path: `/${localeRegex}/sign-in`,
		isPrivate: false,
		component: AsyncSignIn,
	},
	{
		path: `/${localeRegex}/sign-up`,
		isPrivate: false,
		component: AsyncSignUp,
	},
	{
		path: `/${localeRegex}/forgot-password`,
		isPrivate: false,
		component: AsyncForgotPassword,
	},
	{
		path: `/${localeRegex}/reset-password/:mid/:ts`,
		isPrivate: false,
		component: AsyncResetPassword,
	},
	{
		path: `/${localeRegex}/forgot-email`,
		isPrivate: false,
		component: AsyncForgotEmail,
	},
	{
		path: `/${localeRegex}/verification/:mid/:cn/:ts`,
		isPrivate: false,
		component: AsyncVerification,
	},
	{
		path: `/${localeRegex}/unregisterVerification/:mid/:cn`,
		isPrivate: false,
		component: AsyncUnregisterVerification,
	},
	{
		path: `/${localeRegex}/csologin/:Param`,
		isPrivate: false,
		component: AsyncCSOLogin,
	},
]

const PrivateRoutes = [
	{
		path: `/${localeRegex}/account`,
		isPrivate: true,
		component: AsyncAccount,
	},
	{
		path: `/${localeRegex}/unregister`,
		isPrivate: true,
		component: AsyncUnRegister,
	},
	{
		path: `/${localeRegex}/contact-us`,
		isPrivate: true,
		component: AsyncContactUs,
	},
	{
		path: `/${localeRegex}/transactions`,
		isPrivate: true,
		exact: true,
		component: AsyncTransactions,
	},
	{
		path: `/${localeRegex}/transactions/:cardNo`,
		isPrivate: true,
		exact: true,
		component: AsyncTransactions,
	},
	{
		path: `/${localeRegex}/transactions/:receiptNo/:autoID`,
		isPrivate: true,
		component: AsyncTransactionDetails,
	},
	{
		path: `/${localeRegex}/cards`,
		isPrivate: true,
		exact: true,
		component: AsyncCards,
	},
	{
		path: `/${localeRegex}/cards/transfer/:cardNo`,
		isPrivate: true,
		component: AsyncTransferBalance,
	},
	{
		path: `/${localeRegex}/cards/add-card`,
		isPrivate: true,
		component: AsyncAddCard,
	},
	{
		path: `/${localeRegex}/cards/report-loss/:cardNo`,
		isPrivate: true,
		component: AsyncReportLossPage,
	},
	{
		path: `/${localeRegex}/cards/verify-gold-card-address`,
		isPrivate: true,
		component: AsyncVerifyGoldCardAddressPage,
	},
	{
		path: `/${localeRegex}/cards/reload/success`,
		isPrivate: true,
		component: AsyncCardReloadReturnPage,
	},
	{
		path: `/${localeRegex}/cards/:cardNo/reload`,
		isPrivate: true,
		component: AsyncCardReloadPage,
	},
	{
		path: `/${localeRegex}/cards/:cardNo/reload`,
		isPrivate: true,
		component: AsyncCardReloadPage,
	},
	{
		path: `/${localeRegex}/cards/:cardNo`,
		isPrivate: true,
		component: AsyncCardDetails,
	},
	{
		path: `/${localeRegex}/rewards`,
		isPrivate: true,
		component: AsyncRewards,
	},
	{
		path: `/${localeRegex}/profile`,
		isPrivate: true,
		exact: true,
		component: AsyncProfile,
	},
	{
		path: `/${localeRegex}/profile/change-password`,
		isPrivate: true,
		component: AsyncChangePassword,
	},
	{
		path: `/${localeRegex}/e-gift/details`,
		isPrivate: true,
		component: AsyncEgiftPurchaseDetail,
	},
	{
		path: `/${localeRegex}/e-gift`,
		isPrivate: true,
		component: AsyncEgiftPurchaseHistoryPage,
	},
]

const SharedRoutes = [
	{
		path: `/${localeRegex}/logout`,
		isPrivate: true,
		component: LogOut,
	},
	{
		path: `/${localeRegex}`,
		exact: true,
		isPrivate: false,
		component: AsyncLandingPage,
	},
	{
		path: `/${localeRegex}/landing`,
		isPrivate: false,
		component: AsyncLandingPage,
	},
	{
		path: `/${localeRegex}/*`,
		isPrivate: false,
		status: 404,
		component: NotFound,
	},
]

export { Routes, PublicRoutes, PrivateRoutes, SharedRoutes, localeRegex }
